var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "20px",
    viewBox: "0 0 26 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "camera") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "camera",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,8.31168831 C11.13632,8.31168831 9.62,9.82649351 9.62,11.6883117 C9.62,13.5501299 11.13632,15.0649351 13,15.0649351 C14.86368,15.0649351 16.38,13.5501299 16.38,11.6883117 C16.38,9.82649351 14.86368,8.31168831 13,8.31168831",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,17.6623377 C9.70242,17.6623377 7.02,14.9823377 7.02,11.6883117 C7.02,8.39428571 9.70242,5.71428571 13,5.71428571 C16.29758,5.71428571 18.98,8.39428571 18.98,11.6883117 C18.98,14.9823377 16.29758,17.6623377 13,17.6623377 M22.62,3.37662338 L18.72,3.37662338 C18.72,1.51168831 17.2068,0 15.34,0 L10.66,0 C8.7932,0 7.28,1.51168831 7.28,3.37662338 L3.38,3.37662338 C1.5132,3.37662338 0,4.88831169 0,6.75324675 L0,16.6233766 C0,18.4883117 1.5132,20 3.38,20 L22.62,20 C24.4868,20 26,18.4883117 26,16.6233766 L26,6.75324675 C26,4.88831169 24.4868,3.37662338 22.62,3.37662338",
    id: "Fill-3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraWhite);
export default __webpack_public_path__ + "static/media/camera_white.156fceb65effafe31e8b943daa9fbe33.svg";
export { ForwardRef as ReactComponent };